import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetTestimonialDataGqlService {
  readonly document = gql`
    query GetTestimonialData {
      testimonialItems(orderBy: createdAt_DESC) {
        page { 
          name 
        }
        name
        subTitle
        text
      }
    }
  `;
}
